import Colors from '../../../../Configs/colors';
import Images from '../../../../Configs/images';

const styles = {
  linearSection: {
    paddingTop: 16,
    paddingBottom: 56,
    backgroundImage: `url(${Images.BottleLayer})`,
    backgroundRepeat: 'no-repeat',
    boxSizing: 'border-box',
    backgroundSize: 'cover',
    zIndex: 1,
  },
  root: {
    background: '#FFF',
    height: '100vh',
    boxSizing: 'border-box',
    overflow: 'auto',
    paddingBottom: 80,
    '& .floating-action': {
      backgroundColor: Colors.white,
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      paddingBottom: 24,
      paddingTop: 4,
      zIndex: 3,
    },
  },
};

export default styles;
